import React from 'react';
import PopOverMenu from '../../../PopOverMenu';

const FilterButtons = (props) => {
    const {
        showTeamTypeOptions,
        teamTypeOptions,
        durationOptions,
        fetchAllResultsOptions,
        defaultTeamType,
        defaultDuration,
        defaultFetchAllResults,
        popOverMenuClassName,
        buttonCssClassName,
        onSelectedTeamType,
        onSelectedDuration,
        onSelectedFetchAllResults,
    } = props;
    return (
        <React.Fragment>
            {showTeamTypeOptions && (
                <PopOverMenu
                    popOverMenuClass={`${popOverMenuClassName || ''} mr8 mb24`}
                    menuItems={teamTypeOptions}
                    onSelected={(option) => {
                        onSelectedTeamType(option.value);
                    }}
                >
                    <button type="button" className={`btn btn-default ${buttonCssClassName || ''}`}>
                        {defaultTeamType.label} <i className="uts uts-expand mr0" />
                    </button>
                </PopOverMenu>
            )}
            <PopOverMenu
                popOverMenuClass={`${popOverMenuClassName || ''} mr8 mb24`}
                menuItems={durationOptions}
                onSelected={(option) => {
                    onSelectedDuration(option.value);
                }}
            >
                <button type="button" className={`btn btn-large btn-default ${buttonCssClassName || ''}`}>
                    {defaultDuration.label} <i className="uts uts-expand mr0" />
                </button>
            </PopOverMenu>
            <PopOverMenu
                popOverMenuClass={`${popOverMenuClassName || ''} mb24`}
                menuItems={fetchAllResultsOptions}
                onSelected={(option) => {
                    onSelectedFetchAllResults(option.value);
                }}
            >
                <button type="button" className={`btn btn-large btn-default ${buttonCssClassName || ''}`}>
                    {defaultFetchAllResults.label} <i className="uts uts-expand mr0" />
                </button>
            </PopOverMenu>
        </React.Fragment>
    );
};
export default FilterButtons;
